import React from 'react';
import styled from 'styled-components';
import {FormGroup} from '../form-features/FormGroup';
import {formElementSetup, insideFormElementSetup} from '../form-setup/formElementSetup';
import IconContainer, {Icon} from '../../elements/icon/Icon';
import {FormLabel} from '../form-features/FormLabel';

export const FormSelectContainer = styled.div`
    ${formElementSetup}
    select {
        ${insideFormElementSetup}
        outline: none!important;
        width: calc(100% - 6px);
    }
    ${IconContainer} {
        position: absolute;
        right: 4px;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
    }
`;

const Wrapper = styled(FormGroup)``;
export const FormSelect = ({children, value, onChange, onBlur, label, defaultValue}) => {
    return (
        <Wrapper>
            {label && <FormLabel>{label}</FormLabel>}
            <FormSelectContainer>
                <Icon icon="ArrowDropDown" />
                <select defaultValue={defaultValue} value={value} onChange={onChange} onBlur={onBlur}>
                    {children}
                </select>
            </FormSelectContainer>
        </Wrapper>
    );
};
